import classNames from 'classnames'
import ColorToggle from './ColorToggle'
import FontToggle from './FontToggle'

const TextField = (props) => {
    const onChange = (e) => {
        props.onChange(props.name, e.target.value, null)
    }

    const onColorChange = (value) => {
        props.onChange(props.name, null, value)
    }

    const onFontChange = (value) => {
        props.onChange(props.name, null, null, value)
    }

    const onUrlChange = (e) => {
        props.onChange(props.name, null, null, null, e.target.value)
    }

    let input = (
        <input
            className="input"
            name={props.name}
            value={props.value.value}
            onChange={onChange}
        />
    )

    if (props.area) {
        input = (
            <textarea
                className="textarea"
                name={props.name}
                value={props.value.value}
                onChange={onChange}
            />
        )
    }

    let urlInput = props.url ? (
        <div
            className={classNames({
                control: true,
                'is-hidden': !props.url,
            })}
        >
            <input
                className="input"
                name={props.name}
                value={props.value.url}
                onChange={onUrlChange}
                placeholder="URL: https://example.com"
            />
        </div>
    ) : null

    return (
        <div className="field is-grouped">
            <label className="label">{props.name}</label>
            <div className="control">{input}</div>
            {urlInput}
            <div className="control is-hidden">
                <ColorToggle
                    index={0}
                    update={onColorChange}
                    value={props.value.color}
                />
            </div>
            <div className="control is-hidden">
                <FontToggle
                    index={0}
                    update={onFontChange}
                    value={props.value.font}
                />
            </div>
        </div>
    )
}

export default TextField
